import { render } from "./AIPostureAnalysis.vue?vue&type=template&id=73e7fc4a&scoped=true"
import script from "./AIPostureAnalysis.vue?vue&type=script&lang=js"
export * from "./AIPostureAnalysis.vue?vue&type=script&lang=js"

import "./AIPostureAnalysis.vue?vue&type=style&index=0&id=73e7fc4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e7fc4a"]])

export default __exports__